import { Component } from 'vue-property-decorator';

import Superbutton from 'tivigi/src/components/Superbutton/Superbutton'
import SM2Base from '../SM2Base';

import BarDisplay from 'tivigi/src/components/BarDisplay/BarDisplay'
import FloatingWindow from 'tivigi/src/components/FloatingWindow/FloatingWindow'
import WithRender from './Basismodul.html';

import Data from 'tivigi/src/components/data/Data/Data'


@WithRender
@Component({
    components: { BarDisplay,  Data, FloatingWindow, Superbutton }
})
export default class Basismodul extends SM2Base {

    pIndicator: any = null

    min: number = 0;
    max: number = 0;


    pDisplayMode = "table"
    pCategory: string | null = null
    pIndicatorType: string = "R"

    local : any = {}

    selectedYear = null

    get displayMode(): string {

        // For absolute indicators, chart display mode is not available:
        if (this.indicator.type == 'A') {
            return "table"
        }
        else {
            return "chart"
        }

        return this.pDisplayMode
    }

    set displayMode(newval: string) {
        this.pDisplayMode = newval;
    }



    get indicator(): any {
        return this.pIndicator
    }

    set indicator(newval: any) {
        this.pIndicator = newval

        if (this.pIndicator != null) {
            let years = this.getYears(this.pIndicator.code)
            this.selectedYear = years[0]            
        }

        this.min = Number.MAX_VALUE;
        this.max = Number.MIN_VALUE;

        if (this.indicator == null) {
            return
        }


        for (let su of this.spatialUnits) {
            let val = this.getValue(su, this.indicator.code, this.selectedYear)

            if (val < this.min) {
                this.min = val;
            }

            if (val > this.max) {
                this.max = val;
            }
        }
    }


    
    get category(): string | null {
        return this.pCategory
    }

    set category(newval: string | null) {
        this.pCategory = newval
        this.indicator = null
    }


    

    get indicatorType(): string {

        if (this.category == null) {
            return this.pIndicatorType
        }

        if (!this.indicatorsExistFor(this.category, 'R')) {
            return 'A'
        }

        if (!this.indicatorsExistFor(this.category, 'A')) {
            return 'R'
        }

        return this.pIndicatorType
    }

    set indicatorType(newval: string) {

        this.pIndicatorType = newval
        this.indicator = null
    }


    get spatialUnitsBasismodul() : Array<any> {
        let result = Array<any>()

        // Deutschland:
        result.push(this.getSpatialUnit("Z0050"))

        // Die 3 Länder:
        result.push(this.getSpatialUnit("Z0051"))
        result.push(this.getSpatialUnit("Z0052"))
        result.push(this.getSpatialUnit("Z0053"))

        // MRN:
        result.push(this.getSpatialUnit("Z0040"))


        result = result.concat(this.getSpatialUnits(['K']))
        return result
    }


   
}


